export default __webpack_public_path__ + "static/media/favicon.3937e849.svg";